import React, { Component } from 'react';
import Button from "../elements/Button";
import globals from "../globals";

class RegisterBlock extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.controller = globals.genericAnimation(this);
    }

    componentWillUnmount() {
        globals.destroy(this.controller);
    }

    render() {
        return (
            <section className="register-prompt">
                <div className="register-prompt-trigger" />
                <div className="row centered">
                    <div className="col-xs-12">
                        <h1><span className="span-call">Call us</span> now. Or let us <span className="span-reg">call you</span></h1>

                        <div className="row padded-block">
                            <div className="col-md-6 col-md-offset-3 col-xs-12">
                                <p>Register your details and one of our telco consultants will call you, at a time that suits you, to answer any questions you may have. No obligation. No hassle.</p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-xs-12">
                                <div className="buttons">
                                    <Button
                                        addClass="button button-phone"
                                        image={this.props.isNbn ? "/images/btn-phone-nbn.svg" : "/images/btn-phone.svg"}
                                        alt="Call us"
                                        action="tel: 1300393835"
                                    />
                                    <Button
                                        addClass="button button-register"
                                        action={(event) => window.slideFormContainer ? window.slideFormContainer.animateIn(event) : null}
                                        image="/images/btn-get-in-touch.svg"
                                        alt="Leave your details"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
    
}

export default RegisterBlock;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/RegisterBlock.js